<template>
  <div class="products">

    <div class="header-row row justify-between items-end">
      <p class="header">
        {{title}}
      </p>
    </div>

    <div class="carousel-wrap">
      <carousel autoWidth
                loop
                :center="viewport.xs"
                :nav="false"
                :items="1"
                :responsive="{
                  0: {
                    margin: 20
                  },
                  [breakpoints.xs]: {
                    margin: 32
                  },
                  [breakpoints.sm]: {
                    margin: 40
                  },
                  [breakpoints.md]: {
                    margin: 80
                  }
                }"
                class="carousel--products">
        <div v-for="(slide, slideIndex) in slides" :key="`slide-${slideIndex}`" class="slide">
          <router-link :to="slide.link">
            <div class="slide-bg-img"
                :style="{backgroundImage: `url(${require(`@/assets/${slide.img.xs}`)})`}">
            </div>
            <div class="slide-content">
              <div class="arrow-wrap arrow--white">
                <div class="arrow">
                  <div class="arrow-tail"></div>
                  <div class="arrow-tip"></div>
                </div>
              </div>
              <p class="slide-title" v-html="slide.title"></p>
              <p class="slide-desc" v-html="slide.desc"></p>
            </div>
          </router-link>
        </div>
      </carousel>
    </div>

  </div>
</template>

<script>
import carousel from 'vue-owl-carousel';

import { mapState } from 'vuex';

export default {
  name: 'Products',
  components: {
    carousel,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      slides: [
        {
          img: {
            xs: 'products_omega.png',
          },
          title: 'Omega Group',
          desc: 'Landing page',
          link: '/case-study/omega',
        },
        {
          img: {
            xs: 'products_nautilius.png',
          },
          title: 'Nautilius Investment',
          desc: 'Corporate websites',
          link: '/case-study/nautilius',
        },
        {
          img: {
            xs: 'products_client.png',
          },
          title: 'Omega web platform',
          desc: 'Web apps',
          link: '/case-study/omega-platform',
        },
      ],
    };
  },
  computed: {
    ...mapState('viewport', ['viewport', 'breakpoints']),
  },
};
</script>


<style scoped lang="stylus">
  @import '../styles/variables';

  .slide{
    position: relative;
    width: 320px;
    height: 420px;
    overflow: hidden;

    .slide-bg-img{
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
      transform: translateZ(0) scale(1);
      transition: transform 0.3s ease;
    }

    img{
      max-width: 100%;
    }

    .slide-content{
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 0 10px 30px 40px;
    }

    .slide-desc{
      font-weight: 400;
      font-size: 15px;
      color: #FFFFFF;
      line-height: 31px;
    }

    .slide-title{
      font-family: 'Dosis', sans-serif;
      font-weight: 200;
      font-size: 38px;
      color: #FFFFFF;
      line-height: 47px;
      margin-bottom: 10px;
    }

    .arrow-wrap{
      position: relative;
      margin-bottom: 15px;
      overflow: hidden;
      max-width: 60px;
      height: 10px;
      transition: padding-left 0.1s cubic-bezier(0.47, 0, 0.75, 0.72);


      .arrow{
        /*37.8px is arrow width*/
        width: 60px;
        display: flex;
        align-items: center;
        transform: translateZ(0) translateX(0);
      }

      .arrow-tail{
        width: 30px;
        height: 2px;
        transform-origin: right;
      }
      .arrow-tip{
        width: 9px;
        height: 0;
        border-style: solid;
        border-width: 4.5px 0 4.5px 7.8px;
      }
    }

    &:hover{
      .slide-bg-img{
        transform: translateZ(0) scale(1.1);
      }
      .arrow-wrap{
        padding-left: 20px;

        .arrow{
          animation-name: arrowToRight, arrowFromLeft;
          animation-duration: 0.1s, 0.2s;
          animation-timing-function: cubic-bezier(0.35, 0.88, 0.71, 1),
            cubic-bezier(0.24, 0.85, 0.75, 1);
          animation-delay: .1s, 0.3s;
          animation-iteration-count: 1, 1;
          animation-direction: normal, normal;
          animation-fill-mode: forwards, forwards;
        }
        .arrow-tail{
          animation-name: arrowTailFromLeft;
          animation-duration: 0.4s;
          animation-timing-function: cubic-bezier(0, 0.57, 0.46, 1.04);
          animation-delay: .35s;
          animation-iteration-count: 1;
          animation-direction: normal;
          animation-fill-mode: forwards;
        }
      }
    }
  }

  .header{
    font-size: 24px;
    font-family: 'Dosis', sans-serif;
    font-weight: 600;
    padding: 0 0 30px 40px;
  }

  .capitalize-xs{
    text-transform: capitalize;
  }

  @media(min-width: $breakpoint-sm-min) {
    .header{
      padding: 0 0 50px 0;
      font-size: 30px;
    }
    .products{
      padding-left: 95px;
      position: relative;

      &:before{
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 231px;
        background: #f7f7f7;
        background: linear-gradient(0deg, #FCFCFC 0%, #F7F7F7 75%);
      }
    }

    .capitalize-xs{
      text-transform: none;
    }

    .slide{
      width: 321px;
      height: 276px;

      .slide-title{
        font-size: 30px;
        line-height: normal;
      }

      .slide-desc{
        font-size: 14px;
      }

    }
  }

  @media(min-width: $breakpoint-md-min) {
    .products{
      padding: 0;
      padding-bottom: 95px;
    }

    .carousel-wrap{
      max-width: 1050px;
      margin: 0 auto;
      overflow: hidden;
    }
    .header-row{
      justify-content: center;
    }
  }
  @media(min-width: $breakpoint-lg-min) {
    .products{
      padding-bottom: 140px;

      &:before{
        height: 315px;
      }
    }
    .carousel-wrap{
      max-width: 1360px;
    }
    .slide{
      width: 400px;
      height: 344px;
      .slide-title{
        font-size: 40px;
        margin-bottom: 20px;
      }
      .slide-desc{
        font-size: 15px;
      }
      .arrow-wrap{
        margin-bottom: 20px;
      }
    }
    .header{
      font-size: 40px;
      padding-bottom: 80px;
    }
  }
</style>

<style lang="stylus">
  @import '../styles/variables';

  @media(min-width: $breakpoint-sm-min) {
    .carousel--products {
      .owl-theme .owl-nav.disabled + .owl-dots {
        margin-top: 60px !important;
      }
    }
  }

  @media(min-width: $breakpoint-md-min){
    .carousel--products .owl-theme .owl-nav.disabled + .owl-dots{
      display: none;
    }
  }
</style>
